var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowsresult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 32,
    viewBox: "0 0 16 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8312 16.555L12.165 20.555C12.0737 20.6919 11.9499 20.8041 11.8048 20.8818C11.6597 20.9594 11.4977 21 11.3331 21H1.49999C1.40877 21 1.31929 20.975 1.24124 20.9278C1.16318 20.8806 1.09953 20.813 1.05717 20.7322C1.01482 20.6514 0.995367 20.5605 1.00093 20.4695C1.0065 20.3784 1.03686 20.2907 1.08874 20.2156L3.99999 16L1.08874 11.7844C1.03686 11.7093 1.0065 11.6216 1.00093 11.5305C0.995367 11.4395 1.01482 11.3486 1.05717 11.2678C1.09953 11.187 1.16318 11.1194 1.24124 11.0722C1.31929 11.025 1.40877 11 1.49999 11H11.3331C11.4977 11 11.6597 11.0406 11.8048 11.1182C11.9499 11.1959 12.0737 11.3081 12.165 11.445L14.8312 15.445C14.9409 15.6093 14.9994 15.8025 14.9994 16C14.9994 16.1975 14.9409 16.3907 14.8312 16.555Z",
    fill: "#F48000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsresult);
export default __webpack_public_path__ + "static/media/arrowsresult.09cf513afb6e1acc2ba867de6b269b83.svg";
export { ForwardRef as ReactComponent };